import React from 'react';

export function htmlParam(param, htmlTag, disabledClassName, classNames) {
    let parStyle = [];

    if (classNames) {
        if (Array.isArray(classNames)) {
            parStyle = classNames;
        }
        else {
            parStyle = [classNames];
        }
    }
    if (disabledClassName) {
        if (param.disabled) { //&& !processedParam.firstload) {
            parStyle.push(disabledClassName);
        }
    }
    let props = {};
    if (parStyle.length > 0) {
        props['className'] = parStyle.join(' ');
    }
    return React.createElement(htmlTag, props, param.value)
}


// WEBPACK FOOTER //
// ./src/lib/utils.js